<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<form @submit.prevent="onSubmit">

		<row>

			<c-col>
				<smart-input required :error="inputErrors.name" :label="$t('attributes.customerName')" v-model="form.name"></smart-input>
				<smart-input :error="inputErrors.cto" :label="$t('pages.clientForm.cto')" v-model="form.cto"></smart-input>
        <smart-input :error="inputErrors.num" :label="$t('pages.clientTable.num')" v-model="form.num"></smart-input>
        <smart-input type="url" placeholder="https://" dir="ltr" :error="inputErrors.update_url" label="עדכון צד 3" v-model="form.update_url"></smart-input>
        <smart-input v-if="isNew" :error="inputErrors.postal" :label="$t('pages.clientTable.zipCode')" v-model="form.postal"></smart-input>
				<smart-input v-if="isNew" :error="inputErrors.address" :label="$t('pages.projectForm.address')" v-model="form.address"></smart-input>
				<cites-select v-if="isNew" v-model="form.city"/>
				<smart-input v-if="isNew" :error="inputErrors.contact_man" :label="$t('pages.projectForm.contact')" v-model="form.contact_man"></smart-input>
				<smart-input v-if="isNew" :error="inputErrors.tel" :label="$t('pages.orderTable.tel')" v-model="form.tel"></smart-input>
				<smart-input v-if="isNew" :error="inputErrors.email" :label="$t('attributes.email')" v-model="form.email"></smart-input>
				<smart-input type="checkbox" :error="inputErrors.outside" label="אפשר הרשמה מבחוץ" v-model="form.outside"></smart-input>


			</c-col>
			<c-col>
				<v-card>
					<v-card-title>{{this.$t('pages.client.prices')}}</v-card-title>
					<v-card-text>
						<smart-input type="number" :error="inputErrors.price" :label="$t('pages.client.price')" v-model.number="form.price" required></smart-input>
						<smart-input type="number" :error="inputErrors.price" :label="$t('pages.client.next_price')" v-model.number="form.next_price"></smart-input>
						<smart-input type="number" :error="inputErrors.price" :label="$t('pages.client.from_3_price')" v-model.number="form.from_3_price"></smart-input>
						<smart-input type="number" :error="inputErrors.price" :label="$t('pages.client.from_4_price')" v-model.number="form.from_4_price"></smart-input>
						<smart-input type="number" :error="inputErrors.price" :label="$t('pages.client.from_5_price')" v-model.number="form.from_5_price"></smart-input>
						<smart-input type="number" :error="inputErrors.price" :label="$t('pages.client.only_niche')" v-model.number="form.only_niche"></smart-input>
						<smart-input type="number" :error="inputErrors.price" :label="$t('pages.client.niche')" v-model.number="form.niche"></smart-input>
						<smart-input type="number" :error="inputErrors.price" :label="$t('pages.client.standard_price')" v-model.number="form.standard_price"></smart-input>
            <smart-input type="number" :error="inputErrors.additional_north_price" label="תוספת צפונית מצפת/בקעת הירדן" v-model.number="form.additional_north_price"></smart-input>
            <smart-input type="number" :error="inputErrors.additional_south_price" label="תוספת דרומית ומזרחית מבאר שבע" v-model.number="form.additional_south_price"></smart-input>
					</v-card-text>
				</v-card>
			</c-col>
		</row>
		<row>
			<c-col>
				<v-btn type="submit" color="success">{{$t("attributes.save")}}</v-btn>
			</c-col>
		</row>
	</form>

</template>


<script>
	import ClientModule from "src/store/modules/Client.module";
	import FormView from "src/mixins/FormView";
	import CitesSelect from "dev/view/measurements/CitesSelect";

	export default {
		props: [],
		name: "client-form",
		components: {CitesSelect},
		data() {
			return {
				form: {
					name: null,
				},
			};
		},
		mixins: [new FormView(ClientModule, "client")],
		computed: {
			isNew() {
				return !this.client.id;
			}
		}
	};
</script>

<style>

</style>
